export default __webpack_public_path__ + "static/media/next-arrow.ce4ba9b4.svg";